<template>
    <div :class="['observer', {'is-mobile': isMobile}]">
        <section class="section-1" ref="sec1" :style="{ height: isMobile ? height: 'auto'}">
            <h3 class="title textfade0 textfade11">{{text.first.title}}</h3>
            <p class="text textfade0 textfade12">{{text.first.text}}</p>
            <picture class="hill">
                <source srcset="../assets/image/observer/mobile/hill.png" media="(max-width: 600px)">
                <img class="p1-line" src="../assets/image/observer/hill@2x.png" alt="" srcset="">
            </picture>
            <picture>
                <source srcset="../assets/image/observer/mobile/p1.jpg" media="(max-width: 600px)">
                <img class="real-pic" src="../assets/image/observer/p1@2x.jpg" alt="" srcset="">
            </picture>
            <img class="plane" src="../assets/image/observer/p1-plane.png" alt="" srcset="">
             <div class="path-wrap">
                 <picture>
                     <source srcset="../assets/image/observer/mobile/p1-device.png" media="(max-width: 600px)">
                    <img class="device" src="../assets/image/observer/device.png" alt="" srcset="">
                </picture>
             </div>
        </section>
        <section class="section-2" ref="sec2" @mouseleave="leave(true)">
            <div @mouseenter="enter" @mouseleave="leave">
                <picture>
                    <source srcset="../assets/image/observer/mobile/soujiu.jpg" media="(max-width: 600px)">
                    <img src="../assets/image/observer/soujiu.jpg" alt="" >
                </picture>
                <div class="tips">
                    <div class="bg"></div>
                    <h4 class="title">{{text.second[0].title}}</h4>
                    <span class="textfade">{{text.second[0].text}}</span>
                </div>
            </div>
            <div @mouseenter="enter" @mouseleave="leave">
                <picture>
                    <source srcset="../assets/image/observer/mobile/zhencha.jpg" media="(max-width: 600px)">
                    <img src="../assets/image/observer/zhencha.jpg" alt="" >
                </picture>
                <div class="tips">
                    <div class="bg"></div>
                    <h4 class="title">{{text.second[1].title}}</h4>
                    <span class="textfade">{{text.second[1].text}}</span>
                </div>
            </div>
            <div @mouseenter="enter" @mouseleave="leave">
                <picture>
                    <source srcset="../assets/image/observer/mobile/tanxian.jpg" media="(max-width: 600px)">
                    <img src="../assets/image/observer/tanxian.jpg" alt="" >
                </picture>
                <div class="tips">
                    <div class="bg"></div>
                    <h4 class="title">{{text.second[2].title}}</h4>
                    <span class="textfade">{{text.second[2].text}}</span>
                </div>
            </div>
            <div @mouseenter="enter" @mouseleave="leave">
                <picture>
                    <source srcset="../assets/image/observer/mobile/xunjian.jpg" media="(max-width: 600px)">
                    <img src="../assets/image/observer/xunjian.jpg" alt="" >
                </picture>
                <div class="tips">
                    <div class="bg"></div>
                    <h4 class="title">{{text.second[3].title}}</h4>
                    <span class="textfade">{{text.second[3].text}}</span>
                </div>
            </div>
        </section>
        <section class="section-3" :class="{ active: !showSec3}" ref="sec3">
             <picture>
                <source srcset="../assets/image/observer/mobile/p3-wap.png" media="(max-width:600px)">
                <img ref="basePic" class="base-pic" src="../assets/image/observer/p3.png" alt="" srcset="">
            </picture>
            <div class="img-wrap">
                <picture>
                    <source srcset="../assets/image/observer/mobile/p3-plane.png" media="(max-width:600px)">
                    <img class="plane" src="../assets/image/observer/p3-plane.png" alt="" srcset="">
                </picture>
                <picture>
                    <source srcset="../assets/image/observer/mobile/p3-left.svg" media="(max-width:600px)">
                     <img class="left" src="../assets/image/observer/p3-left.svg" alt="" srcset="">
                </picture>
                <picture>
                    <source srcset="../assets/image/observer/mobile/p3-right.svg" media="(max-width:600px)">
                    <img class="right" src="../assets/image/observer/p3-right.svg" alt="" srcset="">
                </picture>
                <img class="xyz" src="../assets/image/observer/p3-xyz.svg" alt="" srcset="">
                <img class="xyz2" src="../assets/image/observer/p3-xyz2.svg" alt="" srcset="">
            </div>
            <div class="captions">
                <h3 :class="['title', 'textfade', {textfade1: showSec3}]">{{text.third.title}}</h3>
                <p :class="['text', 'textfade', {textfade2: showSec3}]">{{text.third.text}}</p>
            </div>
        </section>
        <section class="section-4" :class="{ active: !showSec4}" ref="sec4">
            <div class="captions">
                <h3 :class="['title', 'textfade', {textfade1: showSec4}]">{{text.forth.title}}</h3>
                <p :class="['text', 'textfade', {textfade2: showSec4}]">{{text.forth.text}}</p>
                <div :class="['icons', 'textfade', {textfade3: showSec4}]" v-if="!isMobile">
                    <div v-for="(item, index) in text.forth.tips" :key="index"><span>{{item}}</span></div>
                </div>
            </div>
            <picture>
                <source srcset="../assets/image/observer/mobile/share.png" media="(max-width:600px)">
                <img ref="basePic" class="base-pic" src="../assets/image/observer/share.png" alt="" srcset="">
            </picture>
        </section>
        <section :class="['section-8']" ref="sec8">
            <div class="captions">
                <h3 :class="['title', 'textfade', {textfade1: showSec8}]">{{text.eighth.title}}</h3>
                <p :class="['text', 'textfade', {textfade2: showSec8}]">{{text.eighth.text}}</p>
            </div>
            <picture>
                <source media="(max-width: 600px)" srcset="../assets/image/observer/mobile/simulation-wap.png">
                <img src="../assets/image/observer/simulation.png" alt="">
            </picture>
        </section>
        <section  :class="['section-7 clearfix',{ active: !showSec7}]" ref="sec7">
            <div class="captions">
                <h3 :class="['title', 'textfade', {textfade1: showSec7}]">{{text.seventh.title}}</h3>
                <p :class="['text', 'textfade', {textfade2: showSec7}]">{{text.seventh.text}}</p>
            </div>
            <div class="device" ref="device">
                <div :class="['car-animate']" :style="`transform: scale(${scale}) translateX(-50%);`"><canvas id="car" width="262" height="469"></canvas></div>
                <picture>
                    <source media="(max-width: ../assets/image/observer/mobile/device-wap-7.png)" srcset="">
                    <img src="../assets/image/observer/device-7.png" alt="">
                </picture>
            </div>
        </section>
        <section :class="['section-5 clearfix',{ active: !showSec5}]" ref="sec5">
            <div :class="['f-right', 'picture']" ref="p4Picture">
                <picture class="base-pic">
                    <source  srcset="../assets/image/observer/mobile/p4.png" media="(max-width: 600px)">                    
                    <img src="../assets/image/observer/p4.png" alt="" ref="p4">
                </picture>
                <div class="cover-imgs" v-if="showSec4">
                    <picture>
                        <source srcset="../assets/image/observer/mobile/1@2x.png" media="(max-width: 600px)">
                        <img class="img-1" src="../assets/image/observer/1@2x.png"  :style="{opacity: pics.includes(0) ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/2@2x.png" media="(max-width: 600px)">
                        <img class="img-2" src="../assets/image/observer/2@2x.png"  :style="{opacity: pics.includes(1) ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/3@2x.png" media="(max-width: 600px)">
                        <img class="img-3" src="../assets/image/observer/3@2x.png"  :style="{opacity: pics.includes(2) ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/4@2x.png" media="(max-width: 600px)">
                        <img class="img-4" src="../assets/image/observer/4@2x.png"  :style="{opacity: pics.includes(3) ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/5@2x.png" media="(max-width: 600px)">
                        <img class="img-5" src="../assets/image/observer/5@2x.png"  :style="{opacity: pics.includes(4)? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/6@2x.png" media="(max-width: 600px)">
                        <img class="img-6" src="../assets/image/observer/6@2x.png"  :style="{opacity: pics.includes(5) ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/7@2x.png" media="(max-width: 600px)">
                        <img class="img-7" src="../assets/image/observer/7@2x.png" :style="{opacity: pics.includes(6) ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/8@2x.png" media="(max-width: 600px)">
                        <img class="img-8" src="../assets/image/observer/8@2x.png" :style="{opacity: pics.includes(7)  ? 1: 0}" alt="">
                    </picture>
                    <picture>
                        <source srcset="../assets/image/observer/mobile/9@2x.png" media="(max-width: 600px)">
                        <img class="img-9" src="../assets/image/observer/9@2x.png" :style="{opacity: pics.includes(8) ? 1: 0}" alt="">
                    </picture>
                </div>
            </div>
            <div class="f-right captions">
                <h3 :class="['title', 'textfade', {textfade1: showSec5}]">{{text.fifth.title}}</h3>
                <p :class="['text', 'textfade', {textfade2: showSec5}]">{{text.fifth.text}}</p>                
                <div class="btns">
                    <ul class="mosaic" ref="mosaic" v-show="imgAnimate < 1">
                        <li v-for="i of 15" :key="i" :class="`grid${i}`" :style="{opacity: grids.includes(i-1)? 1: 0}"></li>
                    </ul>
                    <button @click="replayAnimation" :style="{position:'relative', opacity: imgAnimate===1 ? 1 :0}">
                        <img src="../assets/image/observer/picture.svg" alt="" srcset="">
                    </button>
                    <span class="tip" :style="{opacity: imgAnimate === 1 ? 1 :0}">
                        <img src="../assets/image/observer/line-blue.png" alt="">
                        <span>{{text.fifth.tips}}</span>
                    </span>
                </div>                
            </div>

        </section>
        <section :class="['section-6',{ active: showSec6}]" ref="sec6">
            <picture>
                <source srcset="../assets/image/observer/mobile/grey-city.jpg" media="(max-width:600px)">
                <img ref="basePic" class="base-pic" src="../assets/image/observer/grey-city.jpg" alt="" srcset="">
            </picture>                    
            <canvas ref="cover" class="cover-img"></canvas> 
            <div class="captions">
                <h3 class="title">{{text.sixth.title}}</h3>
                <p class="text">{{text.sixth.text}}</p>
            </div>
        </section>
        <section class="section-9" ref="sec9">
            <h3 class="title">{{ text.ninth.title }}</h3>
            <ul class="content">
                <li v-for="(item, index) in text.ninth.tips[0]" :key="index"><span>{{item}}</span></li>
            </ul>
            <ul class="content">
                <li v-for="(item, index) in text.ninth.tips[1]" :key="index"><span>{{item}}</span></li>
            </ul>
        </section>
        <params :params="text.params" id="sec8"></params>    
        <foot id="sec9"></foot>
    </div>
</template>
<script>
import { isMobile } from '@/js/utils';
import { observer } from '@/js/text';
import { mapState, mapMutations } from 'vuex';
import * as $ from 'jquery';

export default {
    name: 'observer',
    metaInfo: {
		meta: [{
			name: 'keywords', 
			content: '无人机, 集成式操控台, 侦查, 观测, 分享,图像识别  目标跟踪,调查取证,秒级成图,  三维重建, 公安巡查, 应急搜救,户外探险, 军事侦查'
		},{
			name: 'description', 
			content: '观测者是一套综合无人飞行侦查系统，主要用于对未知地形地貌快速侦查还原，强大的成图与云端分享能力，支持多端实时同步查看，轻巧易用便于携带。广泛应用于公安巡查、应急搜救及户外探险等场景。'
		}]
	},
    data() {
        return {
            height: '100vh',
            width: 0,
            showSec3: false,
            showSec4: false,
            showSec5: false,
            showSec6: false,
            showSec7: false,
            showSec8: false,
            isMobile: false,
            imgAnimate: false,
            grid: 1,
            grids: [],
            mosaicTimer: null,
            picTimer: null,
            pic: 1,
            scale: 1,
            pics: [],
            frameId: null,
            imgTimer: null,
            coverImg: null,
            transferTimer: null,
            cars: [],
            carN: 0,
            carTimer: null
        }
    },
    components: {
        Params: () => import('@/components/params-observer.vue'),
        Foot: () => import('@/components/footer.vue')
    },
    watch: {
        isMobile() {
            this.$refs.cover.width = window.innerWidth * devicePixelRatio
            this.$refs.cover.height = 1.216*window.innerWidth * devicePixelRatio
        }
    },
    computed: {
        ...mapState(['headerStyle']),
        text() {
            return this.$route.params.lang === 'CN' ? observer.CN : observer.EN
        }
    },
    methods: {
        ...mapMutations(['setHeaderStyle']),
        // 第二屏的鼠标移入移出事件
        enter(e) {
            clearTimeout(this.transferTimer)
            let child = Array.from(this.$refs.sec2.childNodes)
            child.forEach(n => {                
                this.transferTimer = setTimeout(() => {
                    n.classList.remove('normal')
                    n.classList.remove('max')
                    n.classList.remove('min')
                     if(e.target === n) {
                        n.classList.add('max')
                    }else {
                        n.classList.add('min')
                    }
                }, 90)
            })
		},
		leave(e) {
            let child = Array.from(this.$refs.sec2.childNodes)
            if(typeof e === 'boolean'){
                clearTimeout(this.transferTimer) 
                setTimeout(() => {
                    child.forEach( n => {
                        n.classList.remove('max')
                        n.classList.remove('min')
                        n.classList.remove('normal')
                    })
                },90)
            }           
            child.forEach( n => {
                n.classList.remove('max')
                n.classList.remove('min')
                n.classList.add('normal')
            })
        },
        // 第四屏动画重播
        replayAnimation() {
            this.imgAnimate = 0
            this.pic = 0
            this.pics = []
            this.grids = []
            this.grid = 0
            this.mosaic()
            this.pictures()
        },
        // 第四屏左侧马赛克动画
        mosaic() {
            clearTimeout(this.mosaicTimer)
            let arr = [4,3,2,1,0,5,6,7,8,9,14,13,12,11,10]
            this.grids = arr.slice(0, this.grid%15)
            this.grid ++
            if(this.grid <= 30) {
                this.mosaicTimer = setTimeout(this.mosaic, 100)
            }else {
                 this.imgAnimate = 1
            }
        },
        // 第四屏右侧动画
        pictures() {
            clearTimeout(this.picTimer)
            let arr = [2,3,8,7,4,1,0,5,6]
            this.pics = arr.slice(0, this.pic)
            this.pic ++
            if(this.pic <= arr.length) {
                this.picTimer = setTimeout(this.pictures, 300)
            }
        },
        resize() {
            this.isMobile = window.innerWidth <= 600 || isMobile()
            this.width = (window.innerWidth > 1200 || isMobile() )? window.innerWidth : 1200            
            this.scale = (this.$refs.device.offsetWidth / 1470).toFixed(3)            
            window.cancelAnimationFrame(this.frameId)
            if(!this.isMobile) {
                let c = this.$refs.cover.getContext('2d')
                c.drawImage(this.coverImg, 0, 0, this.$refs.cover.width, this.$refs.cover.height)
            }
        },
        // 秒级成图覆盖层
        drawCover() {            
            let c = this.$refs.cover.getContext('2d')
            let h = this.$refs.cover.height
            let w = this.$refs.cover.width
            c.clearRect(0,0, w, h)

            const addColorStop = (radial) => {
                radial.addColorStop(0, 'rgba(255,255,255,1)')
                radial.addColorStop(0.8, 'rgba(255,255,255,1)')
                radial.addColorStop(1, 'rgba(255,255,255,0)')
            }
            let r = 0
            const scale = () => {
                c.clearRect(0,0, w, h)    
                c.beginPath()
                let radialGradient1 = c.createRadialGradient(w,0, 0 ,w,0, r)
                addColorStop(radialGradient1)
                c.arc(w, 0 , r, 0, Math.PI*2, true)
                c.fillStyle = radialGradient1
                c.fill()
                c.closePath()
                c.save()   
                c.globalCompositeOperation = "source-in"
                c.drawImage(this.coverImg, 0, 0, w, h)
                c.restore()
                if(r < w * 12) {
                    r += 10
                    this.frameId = requestAnimationFrame(scale)
                }else {
                    c.drawImage(this.coverImg, 0, 0, w, h)
                }               
            }  
            if(this.coverImg.complete) {
                scale()
            }else {
                setTimeout(this.drawCover, 1000)
            }
        },
        initEvent(e) {
            let h9 = this.isMobile ? 400 : 826
            let h10 = 1762
            let t = document.documentElement.scrollTop || document.body.scrollTop
            let nw = this.$refs.sec1.offsetWidth
            let nh = this.$refs.sec1.offsetHeight
            let ch = window.innerHeight > 520 || this.isMobile ? window.innerHeight : 520
            let h4 = this.isMobile ? this.$refs.sec4.offsetHeight : 400 / 600 * nw / 2 + 236
            let h5 = this.isMobile ? this.$refs.sec8.offsetHeight : 610 / 636 * nw * 0.53 + nw * 0.06 + 40
            let h6 = this.isMobile ? this.$refs.sec7.offsetHeight : 164 + 626 / 825 * nw * 0.62
            let h7 = this.isMobile ? this.$refs.sec5.offsetHeight : nw * 0.51
            
            if(!this.isMobile) {
                if(t < nh + ch - 40 && this.headerStyle !== 'light') {
                    this.setHeaderStyle({headerStyle: 'light'})
                }
                if(t >= nh + ch - 40 && t < nh * 2 + ch - 40  && this.headerStyle !== 'dark') {
                    this.setHeaderStyle({headerStyle: 'dark'})
                }
                if(t >= nh * 2 + ch - 40 && t < nh * 2 + ch + h4 - 40  && this.headerStyle !== 'light') {
                    this.setHeaderStyle({headerStyle: 'light'})
                }
                if(t >= nh * 2 + ch + h4 - 40 && t < nh * 2 + ch + h4 + h5 - 40  && this.headerStyle !== 'dark') {
                    this.setHeaderStyle({headerStyle: 'dark'})
                }
                if(t >= nh * 2 + ch + h4 + h5 - 40 && t < nh * 2 + ch + h4 + h5 + h6 - 40  && this.headerStyle !== 'light') {
                    this.setHeaderStyle({headerStyle: 'light'})
                }
                if(t >= nh * 2 + ch + h4 + h5 + h6 - 40 && t < nh * 3 + ch + h4 + h5 + h6 + h7 + h9 + h10 - 40  && this.headerStyle !== 'dark') {
                    this.setHeaderStyle({headerStyle: 'dark'})
                }
                if(t >= nh * 3 + ch + h4 + h5 + h6 + h7 + h9 + h10 - 40 && this.headerStyle !== 'light') {
                    this.setHeaderStyle({headerStyle: 'light'})
                }
            }
            
           if(t >= 0.4 * nh + ch && !this.showSec3) {
                this.showSec3 = true   
                this.getCar()             
            }
            if(t >= 1.4 * nh + ch && !this.showSec4) {
                this.showSec4 = true                
            }
            if(t >= 2 * nh + ch + 0.4 * h4 && !this.showSec8) {
                this.showSec8 = true
            }
            if(t >= 2 * nh + ch + h4 + 0.4 * h5 && !this.showSec7) {
                this.showSec7 = true
            }
            if(t >= 2 * nh + ch + h4 + h5 + 0.4 * h6 && t < nh * 2 + ch + h4 + h5 + h6 + h7 - 20 && this.pic === 1) {
                if(!this.mosaicTimer){
                    this.mosaic()                    
                }
                if(!this.picTimer) {
                    this.pictures()
                }
                this.showSec5 = true
            }
            if(t >= 2 * nh + ch + h4 + h5 + h6 + 0.4 * h7 && t < nh * 3 + ch + h4 + h5 + h6 + h7 - 20 && !this.showSec6) {
                if(!this.showSec6) {
                    this.drawCover()
                }
                this.showSec6 = true
            }
            if(t > nh * 2 + ch + h4 + h5 + h6 + h7 - 20 || t < nh * 2 + ch + h4 + 0.4 * h5) {
                clearTimeout(this.picTimer)
                this.picTimer = null
                this.pics = []
                this.pic = 1
            }
            if(t > nh * 3 + ch + h4 + h5 + h6 + h7 - 20 || t < nh * 2 + ch + h4 + 1.4 * h5) {
                this.showSec6 = false
            }
        },
        getCar() {           
            for(let i = 0; i< 70; i++) {
                let img = new Image
                img.src = require(`@/assets/image/observer/car/car_000${i}.jpg`)
                img.onload = () => {
                    this.cars[i] = img
                    if(this.cars.length === 70 && this.cars.every(j => j)) {
                        this.drawCar()
                    }
                }
            }
        },
        drawCar() {
            clearTimeout(this.carTimer)
            let canvas = document.getElementById('car')
            let ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, 262, 469)
            ctx.drawImage(this.cars[this.carN % 70], 0, 0, 262, 469)
            this.carN ++
            this.carTimer = setTimeout(this.drawCar, 50)
        }
    },
    async mounted() {       
        this.$nextTick(() => {            
            this.height =this.$refs.sec1.offsetHeight + 'px'
            this.width = (window.innerWidth > 1200 || isMobile() )? window.innerWidth : 1200
            this.$refs.cover.width = this.width * devicePixelRatio
            this.scale = (this.$refs.device.offsetWidth / 1470).toFixed(3)           
        })        
        this.isMobile = window.innerWidth <= 600 || isMobile()
        this.setHeaderStyle({ headerStyle: 'light' })
        this.coverImg = new Image()   
        if(this.isMobile){
            this.$refs.cover.height = 1.216 * document.documentElement.clientWidth * devicePixelRatio
            this.coverImg.src = require('@/assets/image/observer/mobile/grey-color.jpg')
        }else{
            this.$refs.cover.height = window.innerHeight * devicePixelRatio
            this.coverImg.src = require('@/assets/image/observer/grey-color.jpg')
        }           
        window.addEventListener('resize', this.resize)
        window.addEventListener('scroll', this.initEvent)
        
    },
    beforeDestroy() {
        clearTimeout(this.mosaicTimer)
        clearTimeout(this.imgTimer)
        clearTimeout(this.carTimer)
        window.removeEventListener('resize', this.resize)
        window.removeEventListener('scroll', this.initEvent)
        window.cancelAnimationFrame(this.frameId)
    }
}
</script>

<style lang="scss">
    @import "../assets/css/observer.scss";
</style>